var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-form',{ref:"form",attrs:{"data":_vm.data,"dataID":_vm.data.id,"model":_vm.formModel},on:{"updateModelItem":_vm.onUpdateModelItem}})}
var staticRenderFns = []

export { render, staticRenderFns }